import React from "react";
import LastUpdated from "./LastUpdated";
import VisitorsCount from "./VisitorsCount";
import { useGetFooterMenusDataQuery } from "../../../redux/services/internal/apiHome";
import { Link } from "react-router-dom";
import Loader from "../../Container/Components/Loader";

const Footer = ({ benchId }) => {
  const { data: footerMenusData, isLoading: isMenuLoading } =
    useGetFooterMenusDataQuery(7);

  if (isMenuLoading) {
    return <Loader />;
  }

  return (
    <>
      <footer>
        <div className="bottom-footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-lg-8 pr-0 a">
                <div className="copy-ryt-txt">
                  <div className="bottom-ftr-links">
                    {footerMenusData?.data
                      ?.filter((item) => item.slug !== "screen-reader") // remove that menu
                      ?.map((item, key) => (
                        <Link to={item.slug} key={key}>
                          {item.title}
                        </Link>
                      ))}
                  </div>
                  <p>
                    Copyright © 2026 Railway Claims Tribunal, Government of
                    India, All Rights Reserved.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                <div className="copy-ryt-txt">
                  <div className="visitrs-sec">
                    <VisitorsCount />
                    <LastUpdated />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
